export const printtimeat = (firetime) => {
  const today = new Date();
  let cr = "";
  if (firetime !== undefined) {
    const time = firetime.toDate();
    if (time.getFullYear() !== today.getFullYear()) {
      cr = String(time.getFullYear()) + "年" + String(time.getMonth()+1) + "月" + String(time.getDate()) + "日に";
    } else {
      const diff = today.getTime() - time.getTime();
      if (diff/1000/60/60/24 < 24) {
        if (diff/1000/60/60/24 < 8) {
          if (diff/1000/60/60 < 24) {
            if (diff/1000/60 < 60) {
              if (diff/1000 < 60) {
                if (diff/1000 < 10) {
                  cr = "たった今";
                } else {
                  cr = String(Math.floor(diff/1000/60)) + "秒前に";
                }
              } else {
                cr = String(Math.floor(diff/1000/60)) + "分前に";
              }
            } else {
              cr = String(Math.floor(diff/1000/60/60)) + "時間前に";
            }
          } else {
            cr = String(Math.floor(diff/1000/60/60/24)) + "日前に";
          }
        } else {
          cr = String(Math.round(diff/1000/60/60/24/7)) + "週間前に";
        }
      } else {
        cr = String(time.getMonth()+1) + "月" + String(time.getDate()) + "日に";
      }
    }
  }
  return (
    <>{cr}</>
  )
}

export default printtimeat;